import Vue from 'vue';
import WebStorage from 'vue-web-storage';

Vue.use(WebStorage, {
  prefix: '', // default is app_
  drivers: ['session', 'local'],
});

export default WebStorage;
